export enum APP_ROUTES {
  TESTS = 'tests',
  NEW_TEST = 'tests/new',
  ADMIN_TESTS = 'admin/tests',
  VIEW_TEST = 'admin/tests/view',
  ADMIN_SETTINGS = 'admin/settings',
  TESTS_LIST = 'tests/list',
  HELP_SUPPORT = '/help-support',
  HOME = 'home',
  TEST_RESULTS = 'test-results',
  SETTINGS = 'settings',
  CONTACT = 'contact',
  HELP = 'help',
  CLINICAL_REPORT = 'reports',
  ADMIN = 'admin',
}

export const ONBOARDING_ROUTES = {
  REGISTER: 'register',
  MAGIC_LINK: 'magic-link',
  MAGIC_LINK_SENT: 'magic-link-sent',
  VERIFY: 'verify',
  MAGIC_LINK_EXPIRED: 'magic-link-expired',
  COMPLETE_PROFILE: 'complete-profile',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  ACCEPT_INVITE: 'accept-invite',
};
